export enum ActivityType {
  'SALES' = 'SALES',
  'ORDER' = 'ORDER',
  'DELIVERY' = 'DELIVERY',
  'SERVICE' = 'SERVICE',
  'APPOINTMENT' = 'APPOINTMENT',
  'CLINICAL' = 'CLINICAL',
  'BILLING' = 'BILLING',
  'ASSESSMENT' = 'ASSESSMENT',
}
